import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import TutorialForm from "../components/TutorialForm";
//import TestForm from "../components/TestForm";
import { check } from "../modules/auth";

const TutorialContainer = ({ history }) => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [phase, setPhase] = useState(0);
  const dispatch = useDispatch();
  const { auth, authError } = useSelector(({ auth }) => ({
    auth: auth.auth,
    authError: auth.authError,
  }));

  /*
   * 이미 start page를 거쳐오며 쿠키 스토어에 쿠키를 저장한 뒤므로 그냥 check() 메소드만 수행
   */
  useEffect(() => {
    dispatch(check());
  }, [dispatch]);

  /*
   * check() 메소드가 auth 객체를 응답하는지 아닌지로 쿠키 유효성 검증
   */
  useEffect(() => {
    if (authError) {
      console.log("오류 발생");
      console.log(authError);
      return;
    } else if (auth) {
      document
        .getElementsByClassName("math-AI-scanning")[0]
        .classList.add("scene-in");
    }
  }, [auth, authError, dispatch]);

  /*
   * tutorial page는 next버튼만 존재하며
   * next 버튼을 통해 다음 튜토리얼 문구를 보여준다.
   * onClick 메소드는 next 버튼을 클릭했을 때 이벤트를 다룬다.
   * buttonClicked state를 통해 더블클릭을 방지
   * TutorialForm에선 phase라는 클래스 네임을 가진 div들이 이미 정의되어있음
   * 이 phase div들을 순서대로 활성화해서 마치 다음 문구를 보여주는 것처럼 만듦
   * 마지막 문구라면 0.5초 뒤 problem-view page로 이동
   */
  const onClick = () => {
    if (!buttonClicked) {
      setButtonClicked(true);
      const phaseDiv = document.querySelectorAll(".phase");
      phaseDiv[phase].classList.remove("on");
      if (phaseDiv.length === phase + 1) {
        phaseDiv[phase].classList.add("off");
        document
          .getElementsByClassName("math-AI-scanning")[0]
          .classList.remove("scene-in");
        document
          .getElementsByClassName("math-AI-scanning")[0]
          .classList.add("scene-out");
        setTimeout(() => {
          history.push("/diagnosis/problem-view");
        }, 500);
      } else {
        phaseDiv[phase + 1].classList.add("on");
        setTimeout(() => {
          setButtonClicked(false);
        }, 500);
      }
      setPhase(phase + 1);
    }
  };

  return (
    <>
      {auth ? (
        <TutorialForm
          name={auth.name}
          grade={auth.grade}
          onClick={onClick}
          t_type={auth.t_type}
        ></TutorialForm>
      ) : (
        <p>no</p>
      )}
    </>
  );
};

export default withRouter(TutorialContainer);
